export const AmbientesEmpresas = {
    BRASIL: 'BR',
    PARAGUAY: 'PY',
    ARGENTINA: 'AR',
    NORTE_AMERICA: 'NA'
};
